/**
 * 认证状态管理
 */
import { create } from 'zustand';
import { UserInfo } from '../services/authApi';

interface AuthState {
  token: string | null;
  user: UserInfo | null;
  isAuthenticated: boolean;
  setAuth: (token: string, user: UserInfo) => void;
  clearAuth: () => void;
  updateUser: (user: Partial<UserInfo>) => void;
}

// 从localStorage加载初始状态
const loadAuthFromStorage = () => {
  try {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');
    if (token && userStr) {
      const user = JSON.parse(userStr);
      return { token, user, isAuthenticated: true };
    }
  } catch (e) {
    console.error('Failed to load auth from storage:', e);
  }
  return { token: null, user: null, isAuthenticated: false };
};

const initialState = loadAuthFromStorage();

export const useAuthStore = create<AuthState>((set) => ({
  ...initialState,
  setAuth: (token: string, user: UserInfo) => {
    console.log('setAuth 被调用:', { token: token?.substring(0, 20) + '...', user });
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    set({ token, user, isAuthenticated: true });
    console.log('setAuth 完成，状态已更新');
    // 验证状态是否真的更新了
    setTimeout(() => {
      const currentState = useAuthStore.getState();
      console.log('setAuth 后的状态:', { 
        token: !!currentState.token, 
        isAuthenticated: currentState.isAuthenticated,
        user: currentState.user?.username 
      });
    }, 0);
  },
  clearAuth: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    set({ token: null, user: null, isAuthenticated: false });
  },
  updateUser: (userUpdates: Partial<UserInfo>) =>
    set((state: AuthState) => {
      const updatedUser = state.user ? { ...state.user, ...userUpdates } : null;
      if (updatedUser) {
        localStorage.setItem('user', JSON.stringify(updatedUser));
      }
      return { user: updatedUser };
    }),
}));
